<template>
  <a-card :bordered="false">
    <a-row slot="title">
      <a-col :span="24">
        <span>火车票</span>
        <span class="tips">开启全国直连酒店服务后，方可开启火车票服务</span>
      </a-col>
    </a-row>
    <a-form-model :model="ruleForm" ref="ruleForm"
                  :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol">
      <a-form-model-item label="同步状态" required>
        <a-radio-group name="radioGroup" v-model="ruleForm.status">
          <a-radio :value="1">开启</a-radio>
          <a-radio :value="0">关闭</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'TrainTickets',
  mixins: [ruleFormMixins],
  data() {
    return {
      submitLoading: false,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      ruleForm: {
        status: 0,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        id: 0
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'TrainTickets', title: '火车票设置' }
    ])
    this.getTrainTickets()
  },
  methods: {
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.getHttpServices().getServerApiService().post('train/server/save', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('同步状态成功')
        this.getTrainTickets()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取信息
    getTrainTickets() {
      this.getHttpServices().getServerApiService().get('train/server/back/' + this.merchantId + '/' + this.platformId).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.ruleForm.id = res.id
        this.ruleForm.status = res.status
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped lang="less">
.tips {
  font-size: 14px;
  padding-left: 15px;
}
</style>